/* ═══════════════════════════════════════════════════════════════════
   AURA PING — cross-tile signal for the Aura Codex.
   Any source tile (Fuel · Power · Force · Energy · Destiny · Aegis)
   calls pingAuraFuse('<pillarId>') when the user completes today's
   ritual. The Aura Codex polls this key and auto-fuses the matching
   ball. 0-cost, localStorage only.
   ═══════════════════════════════════════════════════════════════════ */

import { fuseSfx } from './ritualSfx';
import { schedulePush } from '../components/AuraRing';

export const AURA_PING_KEY = 'aura_source_pings_v1';
const AURA_CODEX_KEY = 'aura_codex_state_v1';

const todayKey = () => {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
};

export const pingAuraFuse = (pillarId) => {
  try {
    const raw = localStorage.getItem(AURA_PING_KEY);
    const s = raw ? JSON.parse(raw) : {};
    s[pillarId] = todayKey();
    localStorage.setItem(AURA_PING_KEY, JSON.stringify(s));
  } catch { /* noop */ }
  /* Fuse the Aura ring right away so the profile line lights without opening the Aura tile. */
  try {
    const raw = localStorage.getItem(AURA_CODEX_KEY);
    let c = raw ? JSON.parse(raw) : null;
    if (!c || c.date !== todayKey()) {
      // New day: reset fuse progress but keep every pillar's alarm schedule.
      const kept = {};
      Object.entries(c?.pillars || {}).forEach(([id, ps]) => {
        kept[id] = { fused: false, tasks: [], window: { start: '', end: '' }, lastFusedAt: 0,
          ...(ps?.alarms ? { alarms: ps.alarms } : {}), ...(ps?.alarmNoteIds ? { alarmNoteIds: ps.alarmNoteIds } : {}) };
      });
      c = { ...(c || {}), date: todayKey(), pillars: kept };
    }
    const prev = c.pillars?.[pillarId] || { tasks: [], window: { start: '', end: '' } };
    if (!prev.fused) {
      c.pillars = { ...(c.pillars || {}), [pillarId]: { ...prev, fused: true, lastFusedAt: Date.now() } };
      localStorage.setItem(AURA_CODEX_KEY, JSON.stringify(c));
    }
    window.dispatchEvent(new Event('aura-fused'));
    schedulePush();
  } catch { /* noop */ }
  try { fuseSfx(); } catch { /* noop */ }
};

export const readAuraPings = () => {
  try {
    const raw = localStorage.getItem(AURA_PING_KEY);
    if (!raw) return {};
    const s = JSON.parse(raw);
    const today = todayKey();
    const out = {};
    Object.entries(s || {}).forEach(([k, v]) => { if (v === today) out[k] = true; });
    return out;
  } catch { return {}; }
};
